import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { authLogin } from "../actions/auth";

const initialState: any = {
  user: {},
  isAuth: false,
  isLoading: false,
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoading: (state: any, action: any) => {
      state.isLoading = action.payload;
    },
    setAuthLogin: (state: any, action: any) => {
      // state.user = action.payload.user;
      // state.isAuth = true;
    },
  },
  extraReducers: (builder: any) => {
    builder.addCase(authLogin.pending, (state: any) => {
      state.isLoading = true;
    });
    builder.addCase(authLogin.fulfilled, (state: any, action: any) => {
      if (action.payload.success) {
        message.success("Logged in successfully");
        state.isLoading = false;
        state.isVisible = false;
        state.user = action.payload.user;
        state.isAuth = true;
      } else {
        message.error(action.payload.message);
        state.isLoading = false;
        state.isVisible = true;
      }
    });
  },
});

export const { setAuthLogin } = AuthSlice.actions;

export default AuthSlice.reducer;
